import React from 'react'
import { CFView, Text } from 'components'
import { css } from 'emotion'
import { pointsMeter, rewardbg, rewardDefault } from 'images'

const RewardsLoadedView = ({
  pointsMeterWidth,
  imageUrl,
  LeftArrowButtonElement,
  RightArrowButtonElement,
  points,
  maxPoints,
  requiredPoints,
  name,
  RedeemRewardButtonElement,
}) => (
  <div className={styles.rewardContainer}>
    <div className={styles.reward}>
      {imageUrl ? (
        <img className={styles.image} src={imageUrl} alt="Reward" />
      ) : (
        <img
          className={styles.rewardDefault}
          src={rewardDefault}
          alt="Reward"
        />
      )}
    </div>
    {LeftArrowButtonElement}
    {RightArrowButtonElement}
    <div className={styles.meter}>
      <div
        className={styles.progress}
        style={{
          width: `${pointsMeterWidth * 27}rem`,
          transition: 'width 2s',
        }}
      >
        <img src={pointsMeter} alt="Meter" />
      </div>
    </div>
    <div className={styles.pointsText}>
      <Text h6 heading2 bold dark>
        {points} / {maxPoints}
      </Text>
    </div>
    <Text h2 heading2 bold dark className={styles.requiredPoints}>
      {requiredPoints === 0 ? 'FREE' : `${requiredPoints} Points`}
    </Text>
    <CFView className={styles.name}>
      <Text h2 heading2 bold dark center>
        {name}
      </Text>
    </CFView>
    <CFView className={styles.redeemButton}>{RedeemRewardButtonElement}</CFView>
  </div>
)

const styles = {
  rewardContainer: css({
    position: 'relative',
    height: '100%',
    width: '100%',
    background: `url(${rewardbg}) no-repeat`,
    backgroundSize: 'contain',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }),
  reward: css({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }),
  image: css({
    position: 'relative',
    right: '0.1rem',
    bottom: '0.2rem',
    width: '12rem',
    borderRadius: '10rem',
  }),
  rewardDefault: css({
    position: 'relative',
    left: '0.2rem',
    bottom: '0.2rem',
    objectFit: 'contain',
    width: '8rem',
  }),
  requiredPoints: css({
    position: 'absolute',
    top: '20.5rem',
  }),
  name: css({
    width: '100%',
    position: 'absolute',
    bottom: '22rem',
    textAlign: 'center'
  }),
  redeemButton: css({
    position: 'absolute',
    bottom: '7rem',
  }),
  meter: css({
    position: 'absolute',
    top: '6.4rem',
    left: '5.5rem',
  }),
  progress: css({
    overflow: 'hidden',
  }),
  pointsText: css({
    position: 'absolute',
    top: '7.9rem',
    right: '6.9rem',
  }),
}

export default RewardsLoadedView
